export const ConvertSlug = (str: any) => {
	str = str.replace(/[`~!@#$%^&*()_\-+=\[\]{};:'"\\|\/,.<>?\s]/g, ' ').toLowerCase();
	str = str.replace(/\s+/g, '-');
	str = str
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/đ/g, 'd');
	return str;
};

export const generateBreadcrumbArray = (url: string) => {
	const parts = url.split('/').filter(part => part.trim() !== '');
	return parts.map((part, index) => {
		const title = part
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');

		const path = index === 0 ? `${part}` : part;

		return { title, path };
	});
}

export const cleanPathValue = (value: string) => {
	const parts = value.split('/').filter(part => part.trim() !== '' && part !== '[sub]');

	if (parts.length > 0) {
		return parts.join('/');
	} else {
		return '';
	}
}

export const toCamelCase = (str: any) => {
	if (!str) return '';
	return str
		.split(' ')
		.map((word: any) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(' ');
}
